import type { SupervisoryBoardMemberKey, TeamMemberKey } from '~/types/layouts'
import {
  ElderlyPeopleIcon,
  PartnerHeart,
  PersonalInjuryIcon,
  PsychologyIcon
} from '#components'

export const boxImages = {
  boerschappen: {
    src: '/images/box/boerschappen.jpg',
    alt: { nl: 'Boerschappen logo', en: 'Boerschappen logo' }
  },
  ekomenu: {
    src: '/images/box/ekomenu.jpg',
    alt: { nl: 'Ekomenu logo', en: 'Ekomenu logo' }
  },
  maggi: { src: '/images/box/maggi.jpg', alt: { nl: 'Maggi logo', en: 'Maggi logo' } },
  plus: { src: '/images/box/plus.jpg', alt: { nl: 'Plus logo', en: 'Plus logo' } },
  vegro: { src: '/images/box/vegro.jpg', alt: { nl: 'Vegro logo', en: 'Vegro logo' } },
  'beter-horen': {
    src: '/images/box/beter-horen.jpg',
    alt: { nl: 'Beter Horen logo', en: 'Beter Horen logo' }
  },
  'kro-ncrv': {
    src: '/images/box/kro-ncrv.jpg',
    alt: { nl: "Campagne 'Lief gebaar'", en: "Campaign 'Lief gebaar' (Kind Gesture)" }
  },
  zomerpicknick: {
    src: '/images/box/zomerpicknick.jpg',
    alt: {
      nl: 'Tafel met verschillende zomerse gerechten voor een picknick',
      en: 'Table with a variety of summer dishes for a picnic'
    }
  }
} as const

export const carouselImages = [
  '/images/carousel/carousel-1.jpg',
  '/images/carousel/carousel-2.jpg',
  '/images/carousel/carousel-3.jpg',
  '/images/carousel/carousel-4.jpg',
  '/images/carousel/carousel-5.jpg',
  '/images/carousel/carousel-6.jpg',
  '/images/carousel/carousel-7.jpg',
  '/images/carousel/carousel-8.jpg',
  '/images/carousel/carousel-9.jpg',
  '/images/carousel/carousel-10.jpg',
  '/images/carousel/carousel-11.jpg'
]

export const infographicImages = {
  'impactonderzoek-2025': {
    src: '/images/infographic/impactonderzoek-2025.png',
    alt: {
      nl: 'Stichting Thuisgekookt Infographic 2025',
      en: 'The Thuisgekookt Foundation Infographic 2025'
    }
  },
  'infographic-2025': {
    src: '/images/infographic/infographic-2025.png',
    alt: {
      nl: 'Stichting Thuisgekookt Impact Onderzoek 2025',
      en: 'The Thuisgekookt Foundation Impact Research 2025'
    }
  }
} as const

export const logoImages = {
  cfb: { src: '/images/logo/cfb.png', alt: { nl: 'CFB logo', en: 'CFB logo' } },
  thuisgekookt: {
    src: '/images/logo/thuisgekookt.png',
    alt: { nl: 'Thuisgekookt logo', en: 'Thuisgekookt logo' }
  },
  'thuisgekookt-dark-mode': {
    src: '/images/logo/thuisgekookt-dark-mode.png',
    alt: { nl: 'Thuisgekookt logo', en: 'Thuisgekookt logo' }
  },
  'thuisgekookt-small': {
    src: '/images/logo/thuisgekookt-small.png',
    alt: { nl: 'Thuisgekookt logo', en: 'Thuisgekookt logo' }
  },
  'thuisgekookt-small-dark-mode': {
    src: '/images/logo/thuisgekookt-small-dark-mode.png',
    alt: { nl: 'Thuisgekookt logo', en: 'Thuisgekookt logo' }
  }
} as const

export const modalImages = {
  meal: {
    src: '/images/modal/meal.jpg',
    alt: { nl: 'Foto van een maaltijd', en: 'Photo of a meal' }
  }
} as const

export const personaImages = {
  annemie: {
    src: '/images/ervaringen-van-anderen/annemie.png',
    alt: { nl: 'Foto van Annemie', en: 'Photo of Annemie' }
  },
  bart: {
    src: '/images/ervaringen-van-anderen/bart.png',
    alt: { nl: 'Foto van Bart', en: 'Photo of Bart' }
  },
  dennis: {
    src: '/images/ervaringen-van-anderen/dennis.png',
    alt: { nl: 'Foto van Dennis', en: 'Photo of Dennis' }
  },
  frans: {
    src: '/images/ervaringen-van-anderen/frans.png',
    alt: { nl: 'Foto van Frans', en: 'Photo of Frans' }
  },
  nick: {
    src: '/images/ervaringen-van-anderen/nick.png',
    alt: { nl: 'Foto van Nick', en: 'Photo of Nick' }
  },
  sanne: {
    src: '/images/ervaringen-van-anderen/sanne.png',
    alt: { nl: 'Foto van Sanne', en: 'Photo of Sanne' }
  },
  simone: {
    src: '/images/ervaringen-van-anderen/simone.png',
    alt: { nl: 'Foto van Simone', en: 'Photo of Simone' }
  },
  sylvana: {
    src: '/images/ervaringen-van-anderen/sylvana.png',
    alt: { nl: 'Foto van Sylvana', en: 'Photo of Sylvana' }
  }
} as const

export const teamMemberImages: Record<TeamMemberKey, string> = {
  adriana: '/images/thuisgekookt-team/adriana.png',
  anne: '/images/thuisgekookt-team/anne.png',
  'anne-kari': '/images/thuisgekookt-team/anne-kari.png',
  anny: '/images/thuisgekookt-team/anny.png',
  aurel: '/images/thuisgekookt-team/fallback/bell-pepper.png',
  bloem: '/images/thuisgekookt-team/fallback/brocolli.png',
  carla: '/images/thuisgekookt-team/carla.png',
  cock: '/images/thuisgekookt-team/cock.png',
  crista: '/images/thuisgekookt-team/fallback/bell-pepper.png',
  douwe: '/images/thuisgekookt-team/douwe.png',
  ellen: '/images/thuisgekookt-team/ellen.png',
  esther: '/images/thuisgekookt-team/esther.png',
  eva: '/images/thuisgekookt-team/fallback/brocolli.png',
  evelien: '/images/thuisgekookt-team/evelien.png',
  flora: '/images/thuisgekookt-team/flora.png',
  florine: '/images/thuisgekookt-team/florine.png',
  gabriella: '/images/thuisgekookt-team/gabriella.png',
  ine: '/images/thuisgekookt-team/ine.png',
  grietje: '/images/thuisgekookt-team/fallback/bell-pepper.png',
  jonas: '/images/thuisgekookt-team/jonas.png',
  jos: '/images/thuisgekookt-team/jos.png',
  'judith-1': '/images/thuisgekookt-team/judith-1.png',
  'judith-2': '/images/thuisgekookt-team/judith-2.png',
  katja: '/images/thuisgekookt-team/katja.png',
  kim: '/images/thuisgekookt-team/kim.png',
  manoucheka: '/images/thuisgekookt-team/fallback/lemon.png',
  merijn: '/images/thuisgekookt-team/fallback/brocolli.png',
  mirte: '/images/thuisgekookt-team/mirte.png',
  natalia: '/images/thuisgekookt-team/fallback/lemon.png',
  parmila: '/images/thuisgekookt-team/fallback/bell-pepper.png',
  parricia: '/images/thuisgekookt-team/parricia.png',
  pascalle: '/images/thuisgekookt-team/pascalle.png',
  paula: '/images/thuisgekookt-team/fallback/brocolli.png',
  sanne: '/images/thuisgekookt-team/sanne.png',
  sonja: '/images/thuisgekookt-team/fallback/lemon.png',
  vera: '/images/thuisgekookt-team/vera.png',
  ymke: '/images/thuisgekookt-team/fallback/bell-pepper.png'
}

export const supervisoryBoardImages: Record<SupervisoryBoardMemberKey, string> = {
  arjan: '/images/rvt/arjan.png',
  jose: '/images/rvt/jose.png',
  thomas: '/images/rvt/thomas.png'
}

export const bulletPointSvgImages = [
  '/svg/bullet-points/list-item-1.svg',
  '/svg/bullet-points/list-item-2.svg',
  '/svg/bullet-points/list-item-3.svg',
  '/svg/bullet-points/list-item-4.svg',
  '/svg/bullet-points/list-item-5.svg',
  '/svg/bullet-points/list-item-6.svg',
  '/svg/bullet-points/list-item-7.svg',
  '/svg/bullet-points/list-item-8.svg',
  '/svg/bullet-points/list-item-9.svg',
  '/svg/bullet-points/list-item-10.svg'
]

export const vegetableListSvgImages = [
  '/svg/vegetable-list/list-item-lemon.svg', // 1
  '/svg/vegetable-list/list-item-broccoli.svg', // 2
  '/svg/vegetable-list/list-item-meat.svg', // 3
  '/svg/vegetable-list/list-item-sweet-pepper.svg', // 4
  '/svg/vegetable-list/list-item-garlic.svg' // 5
]

export const rootSvgImages = {
  quote: { src: '/svg/quote.svg', alt: { nl: 'Quote', en: 'Quote' } },
  'thuisgekookt-dieetwensen': {
    src: '/svg/thuisgekookt-dieetwensen.svg',
    alt: { nl: 'Thuisgekookt Logo', en: 'Thuisgekookt Logo' }
  },
  'thuisgekookt-succes': {
    src: '/svg/thuisgekookt-succes.svg',
    alt: { nl: 'Thuisgekookt Logo', en: 'Thuisgekookt Logo' }
  },
  'thuisgekookt-succes-dark': {
    src: '/svg/thuisgekookt-succes-dark.svg',
    alt: { nl: 'Thuisgekookt Logo', en: 'Thuisgekookt Logo' }
  }
} as const

export const donationImages = {
  // Technically a video, but it's played muted (no subtitles needed) and behaves more like a .gif
  'success-animated': {
    src: '/images/donatie/success-animated.mp4',
    alt: {
      nl: 'Het thuisgekookt team juicht om jouw donatie!',
      en: 'The Thuisgekookt is cheering for your donation!'
    }
  },
  'success-static': {
    src: '/images/donatie/success-static.png',
    alt: {
      nl: 'Het thuisgekookt team juicht om jouw donatie!',
      en: 'The Thuisgekookt is cheering for your donation!'
    }
  }
}

export const thirdPartyImages = {
  mepal: {
    src: '/images/derde-partij/mepal.png',
    alt: {
      nl: 'Mepal logo',
      en: 'Mepal logo'
    }
  },
  'mepal-dark-mode': {
    src: '/images/derde-partij/mepal-dark-mode.png',
    alt: {
      nl: 'Mepal logo',
      en: 'Mepal logo'
    }
  },
  plus: {
    src: '/images/derde-partij/plus.png',
    alt: {
      nl: 'PLUS logo',
      en: 'PLUS logo'
    }
  }
}

export const woningcorporatieImages = {
  'woningcorporatie-samen-bouwen': {
    src: '/images/woningcorporatie/woningcorporatie-samen-bouwen.png',
    alt: {
      nl: 'Infographic over hoe Stichting Thuisgekookt zorgzame buurten bouwt via maaltijdkoppelingen.',
      en: 'Infographic about how The Thuisgekookt Foundation builds caring neighbourhoods through meal matching.'
    }
  },
  'woningcorporatie-samen-werken': {
    src: '/images/woningcorporatie/woningcorporatie-samen-werken.png',
    alt: {
      nl: 'Infographic over de driestapssamenwerking tussen Stichting Thuisgekookt en woningcorporaties.',
      en: "Infographic about The Thuisgekookt Foundation's three-step collaboration with housing corporations."
    }
  },
  award: {
    src: '/images/woningcorporatie/vernieuwde-stad-award.jpeg',
    alt: {
      nl: 'Uitreiking van de Vernieuwde Stad Award',
      en: 'Award ceremony for the Vernieuwde Stad Award'
    }
  }
}

export const svgIcons = {
  'elderly-people': ElderlyPeopleIcon,
  'partner-heart': PartnerHeart,
  'personal-injury': PersonalInjuryIcon,
  psychology: PsychologyIcon
} as const
